// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import * as React from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';

import type { CommonActionProps } from './types.actions';
import type { GridItem } from '../../types';

type Props = {
  item: GridItem,
  field: string,
  title?: string,
};

class FieldViewerAction extends React.Component<CommonActionProps & Props> {
  render() {
    const { item } = this.props;
    const content = item ? item[this.props.field] : '';

    return (
      <FormGroup controlId="formControlsTextarea">
        <ControlLabel>{this.props.title || this.props.field}</ControlLabel>
        <FormControl
          disabled={this.props.disabled}
          componentClass="textarea"
          readOnly
          value={this.props.disabled ? '' : content}
          css={{
            height: '35px !important',
            padding: '5px',
          }}
        />
      </FormGroup>
    );
  }
}

export default FieldViewerAction;
